module.exports = function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_functionName.js
// module id = 380
// module chunks = 35783957827783 114276838955818